import React from 'react'
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom'
import { SectionKey, pageHeader, sectionOf } from '../../sections'
import SectionHeader from '../ui/SectionHeader'

interface SectionLayoutProps {
    section: SectionKey
    // Legacy links used /<section>?id=<id>; they are sent to this update page
    legacyUpdatePath?: (id: string) => string
}

const SectionLayout: React.FC<SectionLayoutProps> = ({ section, legacyUpdatePath }) => {
    const [searchParams] = useSearchParams()
    const { pathname } = useLocation()
    const legacyId = searchParams.get('id')

    if (legacyId && legacyUpdatePath) return <Navigate to={legacyUpdatePath(legacyId)} replace />

    const current = sectionOf(section)
    const { title, summary } = pageHeader(current, pathname)

    return (
        <>
            <SectionHeader section={current} title={title} summary={summary} />
            <Outlet />
        </>
    )
}

export default SectionLayout
